// NS: モバイルの商品カルーセルは ::-webkit-scrollbar を指定していたが、
// iOS Safari はこれを描画しないため「横にスライドできる」ことが伝わらなかった。
// スクロール位置を示すドットと、右端の「まだ続く」ぼかしを自前で制御する。
// PC（min-width:768px）ではカルーセルではなくグリッド表示なので何もしない。
(() => {
  const MOBILE = '(max-width: 767px)';
  const MAX_DOTS = 8;

  /** @param {HTMLElement} rail */
  function setup(rail) {
    const wrap = rail.closest('.nsf-railwrap');
    if (!wrap) return;
    const hint = wrap.parentElement?.querySelector('.nsf-swipe');
    const dots = hint ? hint.querySelector('.nsf-dots') : null;
    const fade = wrap.querySelector('.nsf-fade');

    let buttons = [];

    function pageCount() {
      if (rail.clientWidth <= 0) return 1;
      return Math.min(MAX_DOTS, Math.max(1, Math.round(rail.scrollWidth / rail.clientWidth)));
    }

    function buildDots(n) {
      if (!dots || buttons.length === n) return;
      dots.textContent = '';
      buttons = [];
      for (let i = 0; i < n; i += 1) {
        const dot = document.createElement('span');
        dot.className = 'nsf-dot';
        dots.appendChild(dot);
        buttons.push(dot);
      }
    }

    function update() {
      const scrollable = rail.scrollWidth > rail.clientWidth + 4;
      // スクロールできないときはヒントごと隠す（商品が少ない場合）
      if (hint) hint.hidden = !scrollable;
      if (fade) fade.style.opacity = scrollable ? '1' : '0';
      if (!scrollable) return;

      const n = pageCount();
      buildDots(n);

      const max = rail.scrollWidth - rail.clientWidth;
      const ratio = max > 0 ? rail.scrollLeft / max : 0;
      const active = Math.round(ratio * (n - 1));
      buttons.forEach((dot, i) => dot.classList.toggle('is-active', i === active));

      // 右端まで来たら「まだ続く」のぼかしを消す
      if (fade) fade.style.opacity = ratio > 0.97 ? '0' : '1';
    }

    rail.addEventListener('scroll', update, { passive: true });
    update();
    return update;
  }

  const updaters = [];

  function init(root) {
    (root || document).querySelectorAll('.nsf-products--carousel').forEach((rail) => {
      if (rail.dataset.nsHint === 'on') return;
      rail.dataset.nsHint = 'on';
      const update = setup(rail);
      if (update) updaters.push(update);
    });
  }

  function refresh() {
    updaters.forEach((fn) => fn());
  }

  function start() {
    if (!window.matchMedia(MOBILE).matches) return;
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // 画面回転やテーマエディタでの再描画に追従する
  window.addEventListener('resize', () => {
    if (window.matchMedia(MOBILE).matches) {
      init(document);
      refresh();
    }
  }, { passive: true });

  document.addEventListener('shopify:section:load', (event) => {
    if (window.matchMedia(MOBILE).matches) init(event.target);
  });
})();
